<div class="smooth-scrolling smooth-scrolling-without-sub-header">

    <!-- foy tv Main START -->

    <div class="tv-video-section">
        <div class="tv-title">
            <span>FOY</span><span class="title-transperant"> TV</span><br /><span class="title-transperant f-45">Turn on
            </span><span class="title-white">healthy skin</span>
        </div>
        <div class="tv-contaimer tv-video-top">
            <div class="tv-video-image">
                <img *ngIf="showImage" [src]="getImage(videoUrlId,true)" alt="image" />
                <a *ngIf="showImage"><img (click)="showLargeVideoView(videoUrlId)"
                        src="assets/images/tv-video-play-button.png" alt="button" /></a>
                <iframe *ngIf="!showImage" [src]="videoLarge" allow='autoplay' frameborder="0" webkitallowfullscreen
                    mozallowfullscreen allowfullscreen></iframe>
            </div>
        </div>
    </div>

    <section class="shop-main">
        <div class="shop-wrap">
            <div class="row">

                <!-- Left side START -->
                <div class="col-lg-3 d-lg-flex d-none leftSide">

                    <div class="filter-main filter-tv">
                        <div class="all-filter">
                            <div class="all-filter-click d-flex">
                                <div class="f-title">FILTER <i class="icon"><img
                                            src="assets/images/filter-white.svg" /></i></div>
                            </div>
                            <div class="all-filter-content">
                                <div class="filterBox mt-2">
                                    <div class="mob-content">
                                        <ul>
                                            <li *ngFor="let cat of mCategoryResponseModal.data; let i = index">
                                                <div class="selection">
                                                    <label>
                                                        <input type="checkbox" name="Category"
                                                            [checked]="categoryId == cat.id"
                                                            (click)="setCategory(cat)" />
                                                        <span class="lbl">{{cat?.name}}</span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Left side END -->

                <!-- right side START -->
                <div class="col-lg-9 col-12 rightSide">
                    <div class="fot-tv-detail">
                        <div *ngIf="categorySelected !=null">
                            <h4 class="h4-font">{{categorySelected?.name}}</h4>
                            <p class="description-font-size" [innerHTML]="categorySelected?.description">
                            </p>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-6 mt-lg-0 mt-4 "
                                *ngFor="let foyTv of mtvChannelResponse.data; let i = index">
                                <div class="tv-content">
                                    <span *ngIf="foyTv.showImage" class="foySpan">
                                        <img [src]="getImage(foyTv.url)" alt="image" />
                                        <a class="foyTvA"><img data-bs-toggle="modal" data-bs-target="#showYoutubeVideo"
                                                (click)="previewVideo(i)" class="foyTvPlayButton"
                                                src="assets/images/tv-video-play-button.png" alt="button" /></a>
                                    </span>
                                    <span *ngIf="!foyTv.showImage" class="foySpan">
                                        <iframe [src]="count == 0 ? showVideo(foyTv.url, i) : foyTv.sanitizeUrl"
                                            allow='autoplay' frameborder="0" webkitallowfullscreen mozallowfullscreen
                                            allowfullscreen></iframe>
                                    </span>
                                    <h4>{{foyTv?.title}}</h4>
                                    <p [innerHTML]="foyTv?.description"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- right side START -->

            </div>
        </div>
    </section>
    <!-- foy tv Main END -->
    <div class="tv-video-section tv-video-bottom">
        <div class="tv-contaimer">
            <div class="tv-video-image">
                <img *ngIf="showImage1" [src]="getMobileImage(videoUrlId,true)" alt="image" />
                <a *ngIf="showImage1"><img (click)="showMobileLargeVideoView(videoUrlId)"
                        src="assets/images/tv-video-play-button.png" alt="button" /></a>
                <iframe *ngIf="!showImage1" [src]="videoLarge"
                    allow='autoplay' frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>